import { TAuthConfig } from 'react-oauth2-code-pkce';
import { store } from '@app/store';
import { setSessionExpired } from '@store/features/auth';
import {
  handOverTokensAndClose,
  hasFreshSharedToken,
  isAuthPopupWindow,
} from '@utils/auth-relay';
import logger from '@app/services/logger';

// Keycloak identity provider alias (e.g. 'azure-ad'), so agents skip the
// Keycloak login page and go straight to Microsoft
const idpHint = process.env.REACT_APP_PKCE_IDP_HINT;

const authConfig: TAuthConfig = {
  clientId: process.env.REACT_APP_PKCE_CLIENT_ID || '',
  authorizationEndpoint: process.env.REACT_APP_PKCE_AUTH_ENDPOINT || '',
  tokenEndpoint: process.env.REACT_APP_PKCE_TOKEN_ENDPOINT || '',
  redirectUri: process.env.REACT_APP_PKCE_REDIRECT_URI || '',
  scope: process.env.REACT_APP_PKCE_SCOPE,
  storage: 'local',
  // Never navigate the Zendesk-embedded document itself to Keycloak/Microsoft -
  // doing so breaks the ZAF SDK's handshake with the parent frame. All login
  // happens in the dedicated popup (see RequestAuth) instead.
  autoLogin: false,
  // Without this the library falls back to a full-page logIn() whenever the
  // refresh token is expired or rejected - including on page load - which
  // would navigate the Zendesk iframe. Show the Sign In screen instead.
  onRefreshTokenExpire: () => {
    // Widgets in other ticket tabs share this storage. If one of them has just
    // renewed the session, the rotated refresh token we used was rejected, but
    // the library will pick up the new tokens via storage events.
    if (hasFreshSharedToken()) {
      logger.info('Auth: adopted a session renewed by another widget');

      return;
    }
    store.dispatch(setSessionExpired(true));
  },
  // Only called after a successful authorization code exchange, so the popup
  // never hands back a session it merely found in storage
  postLogin: () => {
    if (isAuthPopupWindow()) handOverTokensAndClose();
  },
  ...(idpHint && { extraAuthParameters: { kc_idp_hint: idpHint } }),
};

export default authConfig;
